import { CustomField } from '../../types'
import { fetchCustomFields } from '../../services/custom-fields.service'
import createBaseStore from '../createStoreHelper'

export const CustomFieldsModule: any = createBaseStore<CustomField>({
  resourceName: 'custom-field',
  plural: 'custom-fields',
  apiCalls: {
    fetchAllApiCall: fetchCustomFields
  }
})
